import { statuses } from "keys"
import { pick } from "lodash"
import { useMutation } from "@tanstack/react-query"
import { useSelector, useDispatch } from "react-redux"
import { actions } from "store"
import { startAudioCuttingFetch } from "store/middlewares/markingWords.crud"
import { alerts as alertKeys } from 'keys'
import { audioCuttingHooks } from ".."

const useStartAudioCutting = () => {
    const dispatch = useDispatch()
    const { assessment } = useSelector(state => state.assessment)
    const { wavesurfer } = useSelector(state => state.wavesurfer)
    const { isCloseSttoper } = useSelector(state => state.markingWords)

    const backToCutting = audioCuttingHooks.useBackToConfirmation()

    // מבצע גם התחלת חיתוך וגם המשך חיתוך
    const { mutateAsync: startAudioCuttingRQ, data: startAudioCuttingData, isPending: startAudioCuttingLoading } = useMutation({ mutationFn: startAudioCuttingFetch })

    const startAudioCutting = async (assessment) => {
        // מבצע גם התחלת חיתוך וגם המשך חיתוך
        const res = await startAudioCuttingRQ(assessment.id)
        const assessmentDTO = pick(res?.data, ["status", "sub_status"])
        console.log(assessmentDTO)
        dispatch(actions.updateAssessment(assessmentDTO))
        dispatch(actions.setIsCloseSttoper(false))
        wavesurfer?.play()
    }

    const continueAudioCutting = async () => {
        // מבצע גם התחלת חיתוך וגם המשך חיתוך
        await startAudioCuttingRQ(assessment.id)
        dispatch(actions.setIsCloseSttoper(false))
        wavesurfer?.play()
    }

    const audioCutting = {
        [statuses.inProgress]: {
            [statuses.audioCuttingInProgress]: {
                label: "המשך חיתוך",
                action: continueAudioCutting,
                // disabled:
                //     //  startAudioCuttingData && 
                //     !isCloseSttoper || continueAudioCuttingLoading
            },
            [statuses.audioCuttingComplete]: {
                label: "החזר לחיתוך",
                action: backToCutting.action,
                loading: backToCutting.loading,
                disabled: backToCutting.loading
            },
            [statuses.wordsComplete]: {
                label: "התחל חיתוך",
                action: startAudioCutting,
                loading: startAudioCuttingLoading,
                disabled: startAudioCuttingLoading
            }
        },
        [statuses.backToCutting]: {
            [statuses.wordsComplete]: {
                label: "התחל חיתוך",
                action: startAudioCutting,
                loading: startAudioCuttingLoading,
                disabled: startAudioCuttingLoading
            }
        },
        [statuses.brokenFile]: {
            "default": {
                label: "החזר לחיתוך",
                action: backToCutting.action,
                loading: backToCutting.loading,
                disabled: backToCutting.loading
            }
        }
    }

    const markWordsValue = audioCutting[assessment.status]?.[assessment.sub_status || "default"]

    const startCutting = {
        label: markWordsValue?.label || "התחל חיתוך",
        color: "secondary",
        action: () => {
            markWordsValue?.action(assessment)
        },
        disabled: markWordsValue?.disabled || !markWordsValue,
        component: 'button',
        width: "200px",
        disabledColor: "gray2",
        loading: markWordsValue?.loading,
        hide: markWordsValue?.hide
    }

    return startCutting
}

export default useStartAudioCutting